(() => {
  if (window.TTCBSizing) return;
  const labels = JSON.parse(document.getElementById('ttcb-sizing-labels')?.textContent || '{}');
  const normalize = value => String(value).trim().toLowerCase().replace(/\s+/g,'').replace(/^(\d+)\((\d+)\)$/, '$1/$2').replace(/^([\d.]+)\(us[\d.]+\)$/, '$1');
  const records = new WeakMap();
  const initialized = new WeakSet();
  const measure = /waist|hip|bust|chest|length|inseam|rise|shoulder|sleeve|height|width|circumference|thigh|opening/;
  const decimal = value => String(Math.round((value + Number.EPSILON) * 10) / 10);
  const convert = (text, from, to) => {
    const clean = text.trim().replace(/\s*(?:inches|inch|in\.?|cm|centimeters|centimetres|["″])\s*$/i,'');
    if (!/^\d+(?:\.\d+)?(?:\s*[-–—~]\s*\d+(?:\.\d+)?)?$/.test(clean)) return text;
    if (from === to) return clean;
    return clean.split(/\s*[-–—~]\s*/).map(n => decimal(Number(n) * (from === 'in' ? 2.54 : 1 / 2.54))).join('–');
  };
  const format = (control, raw) => control?.dataset.ttcbSizeLabel || raw;
  window.TTCBSizing = {format};
  const addMapping = (mapping, raw, label) => {
    const key = normalize(raw);
    if (mapping.has(key) && mapping.get(key) !== label) mapping.set(key, null);
    else if (!mapping.has(key)) mapping.set(key, label);
  };
  const getUnit = (table, host, rows) => {
    let context = table.caption?.textContent || '';
    let sibling = table.previousElementSibling;
    for (let i=0; i<3 && sibling && sibling.tagName !== 'TABLE'; i++, sibling=sibling.previousElementSibling) {
      context += ' ' + sibling.textContent;
      if (/^H[1-6]$/.test(sibling.tagName)) break;
    }
    const content = context + ' ' + rows[0].join(' ');
    const inContext = /\binch(?:es)?\b|\bINCH\b|\(in\)/i.test(content);
    const cmContext = /\bcm\b|centimet(?:er|re)s?/i.test(content);
    if (inContext && cmContext) return null;
    if (inContext) return 'in';
    if (cmContext) return 'cm';
    const cells = rows.slice(1).flatMap(row => row.slice(1));
    const markedIn = cells.some(cell => /["″]|\binches?\b|\bin\.?$/i.test(cell));
    const markedCm = cells.some(cell => /\bcm\b|centimet/i.test(cell));
    if (markedIn && !markedCm) return 'in';
    if (markedCm && !markedIn) return 'cm';
    const verified = window.TTCBVerifiedSizeUnits?.[host.dataset.productHandle];
    return verified?.signature === JSON.stringify(rows) ? verified.unit : null;
  };
  const buildTable = (chart, unit) => {
    const table = document.createElement('table');
    const caption = document.createElement('caption');
    caption.textContent = labels.measurements + (chart.unit ? ' · ' + (unit === 'in' ? labels.inches : labels.centimeters) : ' · ' + labels.original);
    table.appendChild(caption);
    const head = document.createElement('thead');
    const heading = document.createElement('tr');
    chart.rows[0].forEach(text => {
      const cell = document.createElement('th'); cell.scope='col';
      cell.textContent = chart.unit && measure.test(text.toLowerCase()) ? text.replace(/\s*\((?:in|cm)\)|\s*\b(?:inches|cm)\b/gi,'') : text;
      heading.appendChild(cell);
    });
    head.appendChild(heading); table.appendChild(head);
    const body = document.createElement('tbody');
    chart.rows.slice(1).forEach(row => {
      const tr = document.createElement('tr');
      tr.dataset.sizeKey = normalize(row[chart.sizeIndex]);
      row.forEach((text, index) => {
        const cell = document.createElement(index === chart.sizeIndex ? 'th' : 'td');
        if(index === chart.sizeIndex) cell.scope='row';
        cell.textContent = chart.unit && measure.test(chart.rows[0][index]?.toLowerCase() || '') ? convert(text,chart.unit,unit) : text;
        tr.appendChild(cell);
      });
      body.appendChild(tr);
    });
    table.appendChild(body);
    const wrapper = document.createElement('div');
    wrapper.className='ttcb-sizing__scroll';wrapper.tabIndex=0;wrapper.setAttribute('role','region');wrapper.setAttribute('aria-label',labels.scroll);
    wrapper.appendChild(table);
    return wrapper;
  };
  const selectedKey = scope => {
    const select = [...scope.querySelectorAll('[data-look-option],[data-property]')].find(el=>/size/i.test(el.dataset.optionName || el.dataset.property || ''));
    if(!select) return '';
    return normalize(select.matches('select') ? select.value : select.querySelector('.active[data-ttcb-raw-value]')?.dataset.ttcbRawValue || '');
  };
  const highlight = host => {
    const record = records.get(host); if(!record) return;
    const key = selectedKey(record.scope);
    host.querySelectorAll('[data-size-key]').forEach(row => {row.dataset.selectedSize=String(Boolean(key) && row.dataset.sizeKey === key);});
    record.scope.querySelectorAll('[data-section-container]').forEach(section=>{
      const group=section.querySelector('[data-property]');if(!/size/i.test(group?.dataset.property || '')) return;
      const selected=group.matches('select') ? group.selectedOptions[0] : group.querySelector('.active[data-ttcb-raw-value]');
      const value=section.querySelector('[data-label-value]');
      if(value && selected?.dataset.ttcbSizeLabel && value.textContent !== selected.dataset.ttcbSizeLabel) value.textContent=selected.dataset.ttcbSizeLabel;
    });
  };
  const initialize = host => {
    if(initialized.has(host)) return;
    initialized.add(host);
    const scope=host.closest('[data-look-card],[data-ttcb-stock-options]') || host;
    const source=host.querySelector('template[data-ttcb-size-source]');
    const charts=[];const mapping=new Map();
    source.content.querySelectorAll('table').forEach(table=>{
      const rows=[...table.rows].map(row=>[...row.cells].map(cell=>cell.textContent.trim().replace(/\s+/g,' ')));
      if(rows.length<2 || rows.some(row=>row.length !== rows[0].length)) return;
      const sizeIndex=rows[0].findIndex(head=>/^size$/i.test(head));
      if(sizeIndex<0) return;
      const usIndex=rows[0].findIndex(head=>/^u\.?s\.?\s*(?:size)?$/i.test(head));
      rows.slice(1).forEach(row=>{
        const raw=row[sizeIndex]; const paired=raw.match(/^([\d.]+)\s*\(\s*US\s*([\d.]+)\s*\)$/i);
        if(paired) addMapping(mapping,paired[1],'US '+paired[2]+' · '+paired[1]);
        else if(usIndex>=0 && row[usIndex]) addMapping(mapping,raw,raw+' · US '+row[usIndex]);
      });
      charts.push({rows,sizeIndex,unit:getUnit(table,host,rows)});
    });
    const sizeControls=[...scope.querySelectorAll('[data-look-option],[data-property]')].filter(el=>/size/i.test(el.dataset.optionName || el.dataset.property || ''));
    let denim=false;
    sizeControls.forEach(group=>{
      const controls=group.matches('select') ? [...group.options] : [...group.querySelectorAll('[data-ttcb-raw-value]')];
      if(group.matches('select') && group.closest('.select')) controls.push(...group.closest('.select').querySelectorAll('[data-ttcb-raw-value]'));
      controls.forEach(control=>{
        const raw=control.dataset.ttcbRawValue || control.value;
        if(!raw) return;
        let label=mapping.get(normalize(raw));
        const pair=raw.match(/^(\d+)\s*(?:\/\s*(\d+)|\(\s*(\d+)\s*\))$/);
        if(!label && pair && Number(pair[2]||pair[3])>=24) {label=pair[1]+' ('+(pair[2]||pair[3])+')';denim=true;}
        if(!label) return;
        control.dataset.ttcbSizeLabel=label;
        if(control.hasAttribute('data-js-option-value')) {
          const text=[...control.childNodes].find(node=>node.nodeType===Node.TEXT_NODE && node.textContent.trim());
          if(text) text.textContent=label;
        } else control.textContent=label;
      });
    });
    if(denim) {
      const note=document.createElement('p');note.className='ttcb-sizing__denim';note.textContent=labels.denim;host.prepend(note);
    }
    const render = unit => {
      host.querySelector('[data-ttcb-size-tables]').replaceChildren(...charts.map(chart=>buildTable(chart,unit)));
      host.querySelectorAll('[data-ttcb-unit]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.ttcbUnit === unit)));
      highlight(host);
    };
    records.set(host,{scope,charts});
    if(charts.length) {
      host.querySelector('[data-ttcb-size-guide]').hidden=false;
      host.querySelector('[data-ttcb-unit-controls]').hidden=!charts.some(chart=>chart.unit);
      render('in');
      host.querySelectorAll('[data-ttcb-unit]').forEach(button=>button.addEventListener('click',()=>render(button.dataset.ttcbUnit)));
      scope.addEventListener('change',()=>setTimeout(()=>highlight(host),0));
      new MutationObserver(()=>highlight(host)).observe(scope,{subtree:true,attributes:true,attributeFilter:['class','selected']});
    }
    scope.dispatchEvent(new CustomEvent('ttcb:sizing-ready',{bubbles:true}));
  };
  const scan = () => document.querySelectorAll('[data-ttcb-sizing]').forEach(initialize);
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',scan,{once:true});else scan();
  new MutationObserver(records=>{if(records.some(record=>[...record.addedNodes].some(node=>node.nodeType===1 && (node.matches?.('[data-ttcb-sizing]')||node.querySelector?.('[data-ttcb-sizing]')))))scan();}).observe(document.documentElement,{childList:true,subtree:true});
})();
